import api from '@pray/shared/utils/api';

import type { RecurringCampaignDetail } from './types';

// GET …/campaigns/recurring/:id — `sendObjectResponse(res, { object: dto })`.
// The api wrapper adds one `data` layer, the server envelope adds another.
export async function getRecurringCampaign({
  artistId,
  recurringCampaignId,
}: {
  artistId: string;
  recurringCampaignId: string;
}): Promise<{ object: RecurringCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}`;
  const response = await api.executeGetRequest<{ data: { object: RecurringCampaignDetail } }>(url);
  return response.data.data;
}
